import { Text } from '@crossfit/design-system'
import style from './style.module.scss'
import { Button, Icon } from '@crossfit/ui'
import Close from './close.svg'
import classNames from 'classnames'
import { useIsLaptopOrAbove } from 'hooks/useMediaQuery'
import { useEffect } from 'react'
import { trackEvent } from 'services/segment'

export type CollapsibleBannerProps = {
  type: 'urgent' | 'nonurgent'
  linkText: string
  linkUrl: string
  title: string
  description: string
  dismiss?: () => void
}

export default function CollapsibleBanner({
  type,
  linkText,
  linkUrl,
  title,
  description,
  dismiss,
}: CollapsibleBannerProps) {
  const isLaptop = useIsLaptopOrAbove()

  useEffect(() => {
    trackEvent({
      event: 'Popup Banner Viewed',
      parent: 'webpage',
      component: 'banner',
      bannerName: title,
      bannerCategory: type === 'urgent' ? 'Expired' : 'Reminder',
      bannerLocation: 'bottom',
      dataId: 'atk-banner',
    })
  }, [])

  return (
    <div
      className={classNames(
        style.wrapper,
        type === 'urgent' && style.urgent,
        type === 'nonurgent' && style.nonUrgent,
      )}
    >
      <div className={style.contentContainer}>
        <div className={style.headerContainer}>
          {type === 'nonurgent' && (
            <Icon name='info' className={style.headerIcon} />
          )}
          <Text type='body' size='md' className={style.header} bold>
            {title}
          </Text>
        </div>
        <Text
          type='body'
          size='sm'
          dangerousHTML={description}
          className={style.description}
        />
      </div>
      {!isLaptop && type !== 'urgent' && (
        <button className={style.closeButton} onClick={dismiss}>
          <img src={Close} />
        </button>
      )}
      <div className={style.buttonContainer}>
        <Button
          variant='secondary'
          rightIcon={<Icon name='arrow-right' />}
          className={style.actionButton}
          onClick={() => {
            trackEvent({
              event: 'Popup Banner Clicked',
              component: 'atk-banner',
              dataId: 'atk-banner-cta',
              parent: 'webpage',
              link: linkUrl,
              text: linkText,
              bannerName: title,
              bannerCategory: type === 'urgent' ? 'Expired' : 'Reminder',
              bannerLocation: 'bottom',
            })
            location.href = linkUrl
          }}
        >
          {linkText}
        </Button>
        {isLaptop && type !== 'urgent' && (
          <Button variant='tertiary' onClick={dismiss}>
            DIMISS
          </Button>
        )}
      </div>
    </div>
  )
}
